/**
 * marketingExplorer.service.ts
 *
 * Wraps POST /ai/marketing-explorer/chat — the full-page AI explorer that can
 * pull date-ranged data from GA4 / Google Ads / Meta and emit chart specs.
 */
import { apiClient } from './apiClient';

export type ChartType = 'line' | 'bar' | 'area';

export interface ChartSpec {
  id: string;
  type: ChartType;
  title: string;
  xKey: string;
  yKeys: Array<{ key: string; label: string; color: string }>;
  data: Array<Record<string, string | number | null>>;
}

export interface ExplorerMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ExplorerChatRequest {
  question: string;
  history?: ExplorerMessage[];
}

export interface ExplorerChatResponse {
  answer: string;
  charts: ChartSpec[];
}

export function chatExplorer(req: ExplorerChatRequest): Promise<ExplorerChatResponse> {
  return apiClient
    .post<{ data: ExplorerChatResponse }>('/ai/marketing-explorer/chat', req)
    .then((r) => r.data.data);
}
